import { createStyles, ErrorOutlineIcon, Typography, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { inject } from 'mobx-react'
import { Component, ErrorInfo, PropsWithChildren, ReactNode } from 'react'
import { I18N } from 'utils/localisation'

const errorBoundaryStyles = () =>
  createStyles({
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    title: {
      padding: '0',
      margin: '0 0 0 8px',
    },
  })

interface IErrorBoundaryInject {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  handleReactCatch: (e: Error, additional?: ErrorInfo | any) => void
}

interface IErrorBoundaryProps extends Partial<IErrorBoundaryInject>, WithStyles<typeof errorBoundaryStyles, false> {
  message?: ReactNode
}

class LeanErrorBoundary extends Component<PropsWithChildren<IErrorBoundaryProps>, { hasError: boolean }> {
  state = { hasError: false }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ hasError: true })
    if (this.props.handleReactCatch) {
      this.props.handleReactCatch(error, info)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={this.props.classes.container}>
          <ErrorOutlineIcon />
          <Typography variant="h5" className={this.props.classes.title}>
            {this.props.message || <I18N term="error_in_component" />}
          </Typography>
        </div>
      )
    }
    return this.props.children
  }
}

export const ErrorBoundary = withStyles(errorBoundaryStyles)(
  inject((ctx: IErrorBoundaryInject, props?: IErrorBoundaryInject) => ({
    handleReactCatch: props?.handleReactCatch ?? ctx.handleReactCatch,
  }))(LeanErrorBoundary)
)
